<template lang="HTML">

  <div class="btn-section bottom" :class="btnTrigger ? '' : 'hide'" ref="btns">
    <div class="btns-wrap">
      <div class="btn-container">
        <div class="row no-gutters flex-sm-column btn-grid">
          <div class="col col-sm-auto btn-wrap">
            <button class="btn btn-outline-light btn-block remix-next pdf" @click="openPDF">View Pdf</button>
          </div>

          <!--HubSpot Call-to-Action Code -->
          <span class="col col-sm-auto hs-cta-wrapper meeting-wrap" id="hs-cta-wrapper-a0df83e1-2bc5-468b-9b90-4535f9eb41cf">
            <span class="hs-cta-node hs-cta-a0df83e1-2bc5-468b-9b90-4535f9eb41cf btn-wrap" id="hs-cta-a0df83e1-2bc5-468b-9b90-4535f9eb41cf">
              <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
              <a href="https://meetings.hubspot.com/darby-kim/marketing-remix-15-minute-call" >
                <img class="hs-cta-img" id="hs-cta-img-a0df83e1-2bc5-468b-9b90-4535f9eb41cf" style="border-width:0px;" src="https://no-cache.hubspot.com/cta/default/526959/a0df83e1-2bc5-468b-9b90-4535f9eb41cf.png"  alt="Schedule a Meeting"/>
              </a>
            </span>
          </span><!-- end HubSpot Call-to-Action Code -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "BottomBtns",
  data() {
    return {
      formData: this.$store.state.formData,
      content: this.$store.state.content,
      docDefinition: this.$store.state.docDefinition,
      btnTrigger: false,
      // docDefinition: this.$store.state.docDefinition,
    };
  },
  methods: {
    openPDF() {
      //console.log(this.docDefinition);

      pdfMake.fonts = {
        // Rajdhani: {
        //   // light: 'Rajdhani-Light.ttf',
        //   normal: "../../assets/fonts/Rajdhani-Regular.ttf",
        //   // medium: 'Rajdhani-Medium.ttf',
        //   italics: "../../assets/fonts/Rajdhani-SemiBold.ttf",
        //   bold: "../../assets/fonts/Rajdhani-Bold.ttf",
        // },
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(this.docDefinition).open();
    },
    hbsptCta() {
      hbspt.cta.load(526959, "a0df83e1-2bc5-468b-9b90-4535f9eb41cf", {});
    },
    windowScrollHandler() {
      const topBtns = document.querySelector(".btn-section.top");
      const rect = topBtns.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      // console.log('bottom - '+rect.bottom);
      // console.log('scrolltop - '+scrollTop);

      if (rect.bottom <= 0) {
        this.btnTrigger = true;
      } else {
        this.btnTrigger = false;
      }
    },
  },
  created() {
    const link = {
      table: {
        widths: ["*", "auto", "*"],
        body: [
          [
            {
              text: "",
              border: [false, false, false, false],
            },
            {
              text: "SCHEDULE MEETING",
              link:
                "https://meetings.hubspot.com/darby-kim/marketing-remix-15-minute-call",
              border: [false, false, false, false],
              fillColor: "#00A6A6",
              noWrap: true,
            },
            {
              text: "",
              border: [false, false, false, false],
            },
          ],
        ],
      },
      style: "link",
      layout: {
        paddingLeft: function(i, node) {
          return 16;
        },
        paddingTop: function(i, node) {
          return 8;
        },
        paddingRight: function(i, node) {
          return 16;
        },
        paddingBottom: function(i, node) {
          return 8;
        },
      },
    };

    // const wmkLogo = {
    //   image: "wmk.png",
    //   link: "https://wmkagency.com",
    //   width: 100,
    //   style: "wmkLogoFooter",
    // };

    const address = {
      text: "2322 Central Park Blvd.",
      style: "details",
    };

    const csz = {
      text: "Denver, C0 80238",
      style: "details",
    };

    const phone = {
      text: "303.771.5675",
      style: "details",
    };

    this.docDefinition.content.push(
      link,
      //wmkLogo,
      address,
      csz,
      phone
    );
  },
  mounted() {
    window.addEventListener("scroll", this.windowScrollHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.btn-section {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  @media only screen and (min-width: 576px) {
    // left: auto;
    // right: 0;
    width: auto;
    bottom: gu(1);
    transition: opacity 1s ease;
  }
}

.hide {
  transition: opacity 1s ease, visibility 0s linear 1s;
  visibility: hidden;
  opacity: 0;
}

.btn-grid {
  @media only screen and (min-width: 576px) {
    align-items: flex-start;
  }
}

.btn-wrap {
  background-color: $colTeal;

  @media only screen and (min-width: 576px) {
    border-radius: 0 0.4rem 0.4rem 0;
    margin-bottom: gu(0.5);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 2px 32px rgba(0, 0, 0, 0.2);

    &:hover {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), 0 4px 40px rgba(0, 0, 0, 0.3);
    }
  }
}

.remix-next {
  font-size: rem-calc(18);
  // color: $white;
  font-weight: $fwBold;
  text-transform: uppercase;
  padding: 0.37em 0.7em;
  border-radius: 0;

  @media only screen and (min-width: 576px) {
    border: none;
    border-radius: 0 0.4rem 0.4rem 0;
  }
}
</style>
